<template>
  <v-dialog
    v-model="active"
    width="500"
  >
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind="{ on }"/>
    </template>

    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title
      >
        Downloads
      </v-card-title>
      <v-card-text class="px-0">
        <v-tabs
          v-model="tab"
          grow
        >
          <v-tab
            key="fields"
          >
            Áreas
          </v-tab>
          <v-tab
            key="attachments"
          >
            Anexos
          </v-tab>
          <v-tabs-items v-model="tab" class="px-2">
            <v-tab-item
              key="fields"
            >
              <v-list
                rounded
              >
                <v-list-item
                  v-for="type in contentTypes"
                  :key="type['value']"
                  @click="() => { onDownloadClick(type['value']) }"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-file</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    {{type["text"]}}
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-tab-item>
            <v-tab-item
              key="attachments"
            >
              <empty-state
                v-if="isLoadingAttachments"
                color="accent"
              >
                <template v-slot:icon>
                  <v-icon class="spinning" color="accent">mdi-sync</v-icon>
                </template>
                <template v-slot:description>
                  Carregando anexos
                </template>
              </empty-state>
              <empty-state
                v-else-if="attachmentsIsEmpty"
              >
                <template v-slot:icon>
                  <v-icon>mdi-folder-open</v-icon>
                </template>
                <template v-slot:description>
                  Nenhum anexo encontrado
                </template>
              </empty-state>
              <v-list
                v-else
                rounded
              >
                <v-list-item-group>
                  <v-list-item
                    v-for="item in attachments"
                    :key="item.name"
                    :href="item.url"
                    target="_blank"
                  >
                    <v-list-item-icon>
                      <v-icon>mdi-attachment</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>{{item.name}}</v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="accent"
          text
          @click="active = false"
          :disabled="isDownloading"
        >
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import {FIELD_CONTENT_TYPES, FIELD_CONTENT_TYPES_DETAILS} from "../../helpers/geometries/constants"
  import download from "downloadjs"
  import {downloadFlightOrderFields, listFlightOrderAttachments} from "../../api/api-flight-provider"
  import {NOTIFICATION_TYPES, NotificationOptions} from "../../helpers/notify"
  import {isEmpty} from "lodash/lang"
  import EmptyState from "../Helpers/EmptyState"

  export default {
    name: "FlightOrderDownloadDialog",
    components: {EmptyState},
    props: {
      order: {
        type: Object,
        required: true,
      }
    },
    data: () => ({
      active: false,
      tab: "fields",
      isDownloading: false,
      isLoadingAttachments: false,
      attachments: []
    }),
    methods: {
      onDownloadClick(contentType) {
        const extraHeaders = {
          responseType: "arraybuffer"
        }
        this.isDownloading = true
        downloadFlightOrderFields(this.$apiAuth.getAuthToken(), this.order["id_flight_order"], contentType, extraHeaders)
          .then((res) => {
            let finalData = res.data
            const fileName = `${this.order["nm_flight_order"] || this.order["id_flight_order"]}.zip`
            const blob = new Blob([finalData], {type: "application/zip"})
            download(blob, fileName, "application/zip")

            this.isDownloading = false
          })
      },
      getFileDownloadEXT(contentType) {
        switch (contentType) {
          case FIELD_CONTENT_TYPES.GEOJSON:
            return "geojson"
          case FIELD_CONTENT_TYPES.X_ESRI_SHAPE:
            return "zip"
          case FIELD_CONTENT_TYPES.KML:
            return "kml"
          default:
            return ""
        }
      },
      onOpen() {
        this.isLoadingAttachments = true
        listFlightOrderAttachments(this.$apiAuth.getAuthToken(), this.order["id_flight_order"])
          .then((res) => {
            this.attachments = res.data.data || []
          })
          .catch(() => {
            this.$notify(new NotificationOptions({
              message: "Erro ao carregar anexos, atualize a página.",
              type: NOTIFICATION_TYPES.WARNING,
            }))
          })
          .finally(() => {
            this.isLoadingAttachments = false
          })
      }
    },
    computed: {
      contentTypes() {
        return FIELD_CONTENT_TYPES_DETAILS
      },
      attachmentsIsEmpty() {
        return isEmpty(this.attachments)
      }
    },
    watch: {
      active(newValue) {
        if (newValue) this.onOpen()
      },
    },
  }
</script>

<style scoped>

</style>
